<template>
  <div class="design-preview">
    <div class="previews" ref="container" :style="paddingOverride + previewsStyle">
      <img v-for="(url, index) in previewUrls"
        :src="url"
        :key="index"
        @click="currentIndex = index"
        @load="imgLoad($event, index)"
        :class="{active: currentIndex === index, rounded}"
        :style="img[index].style"
        >
    </div>
    <div class="button-holder">
      <button v-if="editButton" @click="$emit('edit')" class="btn edit-design"><i class="far fa-edit"/> Edit Design</button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scss/colors.scss';

.previews {
  width: 100%;
  padding-top: 80%;
  position: relative;
}
img {
  background: white;
  position: absolute;
  box-shadow: 0 0 5px 0px $gray-0, 2px 2px 2px 0px rgba(0,0,0,0.5);
}
img.rounded {
  // The font size of the img will be adjusted so
  // that 1em is always correct
  border-radius: 1em !important;
}
img.active {
  z-index: 2;
  box-shadow: 0 0 5px 0px $gray-0, 5px 5px 5px 2px rgba(0,0,0,0.5);
}
// Ensure the "edit design" button, if present, is flush right
// with the container.
.button-holder {
  text-align: right;
  button {
    padding-right: 0;
  }
}
</style>

<script>
import debounce from 'lodash/debounce';
export default {
  props: ['previewUrls', 'rounded', 'editButton'],
  data() {
    return {
      currentIndex: 0,
      img: {
        0: {w: null, h: null, style:'display: none;'},
        1: {w: null, h: null, style:'display: none;'}
      },
      numLoaded: 0,
      previewsStyle: 'font-size: 25px;',
      paddingOverride: '',
    }
  },
  mounted() {
    // onResize called for first time after styles are calculated
    this.onResize = debounce(() => this.calcRounded(), 100);
    window.addEventListener('resize', this.onResize, {passive: true});
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize, {passive: true});
  },
  methods: {
    imgLoad(evt, index) {
      let i = this.img[index], t = evt.target;
      i.w = t.naturalWidth; i.h = t.naturalHeight;
      if (++this.numLoaded >= this.previewUrls.length) {
        this.calcStyles();
      }
      console.log('imgLoad', index, this.img);
    },
    calcStyles() {
      let {0: i0, 1: i1} = this.img;
      const TL = 'top: 0; left: 0;', BR = 'bottom: 0; right: 0;', C = 'top: 50%; transform: translateY(-50%);', CONTAINER_ASPECT = 0.80;
      function cssW(i, max=100) { return `width: ${i.w}px; max-width: ${max}%;`; }
      function cssH(i, max=100) { return `height: ${i.h}px; max-height: ${max}%;`; }
      function portrait({w, h}) { return w < h; }
      function pctW(i) { return CONTAINER_ASPECT * i.w / i.h; }
      this.paddingOverride = '';
      if (!i1.w) {
        // Single card
        if (portrait(i0)) {
          // Center horizontally
          i0.style = 'top: 0; left: 50%; transform: translateX(-50%);' + cssH(i0);
        } else {
          // Use static positioning, so the container doesn't have extra vertical space
          i0.style = 'position: static;' + cssW(i0);
          this.paddingOverride = 'padding-top: 0;';
        }
      } else {
        // Two cards
        let p0 = portrait(i0), p1 = portrait(i1);
        if (p0 && p1) {
          // The cards should fit side-by-side
          // Overlap a little for effect
          i0.style = cssH(i0, 90) + `top: 0; right: 48%`;
          i1.style = cssH(i1, 90) + `bottom: 0; left: 48%`;
        } else if (p0 || p1) {
          // Mixed cards
          let max1 = 80, max2 = 80;
          if (p0) { max1 = pctW(i0) * 100; }
          else { max2 = pctW(i1) * 100; }
          i0.style = cssW(i0, max1) + 'left: 0;' + C;
          i1.style = cssW(i1, max2) + 'right: 0;' + C;
        } else {
          i0.style = cssW(i0, 90) + TL;
          i1.style = cssW(i0, 90) + BR;
        }
      }
      this.$nextTick(this.calcRounded);
    },
    calcRounded() {
      let c = this.$refs.container, maxSize = 0;
      c.childNodes.forEach(i => maxSize = Math.max(maxSize, i.width, i.height));
      // maxSize pixels = 3.5"  rounded corner = 1/4"   zoom = 2x   3.5/(1/4)/2 = 28
      // TODO is this right? looks a bit small.
      this.previewsStyle = `font-size: ${maxSize / 28}px;`
    }
  },
  computed: {
    currentUrl() {
      return this.previewUrls[this.currentIndex];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/OverlappedPreview.vue